export enum MemberRoleScopeType {
  global = 'global',
  room = 'room',
  stories = 'stories',
  surveysInRoom = 'surveysinroom',
}
